import { useEffect, useState } from 'react';

import { fetchReadyForReview } from '../services/truckAssets';

function useNeedsReview() {
	const [ assets, setAssets ] = useState( [] );
	const [ loading, setLoading ] = useState( false );
	const [ error, setError ] = useState( null );

	useEffect( () => {
		( async () => {
			setLoading( true );

			try {
				const readyForReview = await fetchReadyForReview();

				setAssets( readyForReview );
			} catch( err ) {
				console.log( err );

				setError( 'There was an error finding images requiring approval' );
			} finally {
				setLoading( false );
			}
		})();
	}, [] );

	return {
		assets,
		loading,
		error
	};
}

export { useNeedsReview };